<template>
  <WdsTag v-if="isOwner" sm primary :data-test="`team-member-account-role-${rowIndex}`">
    {{ $t('Owner') }}
  </WdsTag>
  <WdsText v-else :text="$t('Member')" :data-test="`team-member-account-role-${rowIndex}`" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsTag, WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { CompanyTeamRole } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const TeamMemberAccountRoleColumn = graphql(`
  fragment TeamMemberAccountRoleColumn on CompanyTeamMember {
    id
    accountRole
  }
`)

const props = defineProps<{
  row: FragmentType<typeof TeamMemberAccountRoleColumn>
  rowIndex?: number
}>()

const isOwner = computed(
  () => useFragment(TeamMemberAccountRoleColumn, props.row).accountRole === CompanyTeamRole.Owner,
)
const rowIndex = computed(() => props.rowIndex ?? 0)
</script>
